<template>
  <v-dialog
      v-model="showModel"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
      style="overflow-y: auto"
  >
    <v-card flat class="fill-height of-y" style="overflow-y: auto; overflow-x: hidden">
      <v-layout column fill-height style="overflow-y: auto; overflow-x: hidden" >
        <!--Card Title-->
        <v-flex shrink >
          <v-card-title class="py-0 pr-2 title-color">
            
            <div style="position: relative">
              <img src="/icons/aiLogo.svg" width="24px" height="24px">
              <v-icon small color="on-surface" style="position: absolute; right: 0; bottom: 0">settings</v-icon>
            </div>
            
            <span class="ml-2 title font-weight-light white--text">AI Admin</span>
            <v-spacer></v-spacer>
            <v-tabs
                v-model="activeTab"
                color="cyan"
                dark
                slider-color="secondary"
            >
              <v-tab
                  v-for="tab in availableTabs"
                  :key="tab.id"
                  ripple
              >
                {{tab.title}}
              </v-tab>
            </v-tabs>
            <v-spacer></v-spacer>
            <v-btn flat icon color="white" class="pa-0 ma-0" @click="showModel = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
        </v-flex>
        <!--Loading-->
        <v-flex v-if="loading" class="pa-2 text-xs-center">
          <v-progress-circular
              :size="40"
              :width="5"
              color="primary"
              indeterminate
          />
        </v-flex>
        <!--Datasets Loaded-->
        <template v-else>
          <v-flex xs12 class="scrollable fill-height">
            <ai-admin-setup v-if="selectedTab === 'setup'"/>
            <ai-dashboard v-if="selectedTab === 'dashboard'"/>
            <ai-admin-chat-settings v-if="selectedTab === 'chatSettings'"/>
<!--            <ai-admin-models v-else-if="selectedTab === 'models'"/>-->
<!--            <ai-admin-users v-else-if="selectedTab === 'users'"/>-->
          </v-flex>
        </template>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
import {codeBaseMixin} from "../../codeBaseMixin";
import format from "date-fns/format";
import {arrSplice, copyText, exportStats} from "@/codeFunctions";
import {getColor} from "random-material-color";
import InputDlg from "@/components/General/InputDlg.vue";
import {mapGetters} from "vuex";
import AiAdminSetup from "@/Ai/Admin/aiAdminSetup.vue";
import AiAdminModels from "@/Ai/Admin/aiAdminModels.vue";
import AiAdminUsers from "@/Ai/Admin/aiAdminUsers.vue";
import aiDashboard from "@/Ai/Admin/aiDashboard.vue";
import AiAdminChatSettings from "@/Ai/Admin/aiAdminChatSettings.vue";

export default {
  mixins: [codeBaseMixin],
  components: {
    AiAdminUsers,
    AiAdminModels,
    AiAdminSetup,
    InputDlg,
    aiDashboard,
    AiAdminChatSettings
  },
  props: {
    show: Boolean,
  },
  data() {
    return {
      loading: false,
      activeTab: 0
    }
  },
  watch: {
    show: {
      immediate: true,
      handler(shown) {
        this.startup();
      }
    },
    campaignUser(val) {
      if (val) {
        this.editCampaignText = val.campaign || ''
        setTimeout(() => {
          this.$refs.campaignCombo.focus();
        }, 500)
      }
      
    }
  },
  methods: {
    async startup() {
      // try {
      //   this.loadingUsers = true;
      //   this.users = await this.$newReq('get', 'billing/allUsers')
      // } catch (e) {
      //   console.log(e)
      //   this.$snack.networkError();
      // } finally {
      //   this.loadingUsers = false
      // }
    },
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo']),
    
    availableTabs() {
      const base = [
        {title: 'Setup', id: 'setup', adminOnly: true},
        {title: 'Dashboard', id: 'dashboard', adminOnly: false},
        {title: 'Chat Settings', id: 'chatSettings', adminOnly: false},
        // {title: 'Models', id: 'models', adminOnly: false},
        // {title: 'Users', id: 'users', adminOnly: false},
      ]
      return base.filter(tab => ((this.userInfo.username.match(/@tasklogix\.co\.za$/gi) && this.userInfo.tasklogixAdmin) || this.userInfo.username.match(/^tlx@/gi)) ? true : !tab.adminOnly);
    },
    
    selectedTab() {
      return this.availableTabs[this.activeTab]?.id
    },
    
    showModel: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val)
      }
    }
    
  }
}
</script>

<style scoped>



</style>
